<template lang="pug">
    v-flex(:class="classObj")
      div(:title='component.label')
        GChart(v-if="isRendered" :style='divStyle', :type="component.typeChart" :data="chartData" :options="chartOptions" :key="componentKey")
        v-alert(v-if="hasErrorMessage" border="bottom" colored-border type="warning" elevation="2", value="true", dismissible) {{ this.result.ErrorMessage[0] }}
</template>

  <script>
    import { GChart } from 'vue-google-charts'

    export default {
      name: 'u-g-chart',

      components: {
        GChart
      },

      props: {
        id: {
          type: String
        },
        component: {
          type: Object
        },
        values: {
          type: Object
        },
        result: {}
      },

      data () {
        return {
          chartData: [],
          chartOptions: {
            title: this.component.title,
            sliceVisibilityThreshold: 0,
            backgroundColor: {
              strokeWidth: 1
            },
            display: 'inline-block'
          },
          componentKey: 0,
          isRendered: false
        }
      },
      computed: {
        hasErrorMessage () {
          if (this.result && this.result.ErrorMessage) return true
          else return false
        },
        divStyle () {
          let height = '300px'
          let width = '100%'
          switch (this.component.printStyle) {
            case 'xs1':
              height = '100px'
              width = '50px'
              break
            case 'xs2':
              height = '100px'
              width = '100px'
              break
            case 'xs3':
              height = '200px'
              width = '150px'
              break
            case 'xs4':
              height = '300px'
              width = '300px'
              break
            case 'xs5':
              height = '250px'
              width = '250px'
              break
            case 'xs6':
              height = '250px'
              width = '500px'
              break
            case 'xs7':
              height = '300px'
              width = '550px'
              break
            case 'xs8':
              height = '300px'
              width = '600px'
              break
            case 'xs9':
              height = '300px'
              width = '700px'
              break
            case 'xs10':
              height = '350px'
              width = '800px'
              break
            case 'xs11':
              height = '350px'
              width = '950px'
              break
            case 'xs12':
              width = '1140px'
              break
          }
          return {
            'height': this.height || this.component.height || height,
            'width': this.width || this.component.width || width
          }
        }
      },
      watch: {
        result: {
          handler (val) {
            if (this.result != null && !this.result.ErrorMessage) {
              this.chartData = []
              this.updateGChart()
              this.refreshChart(true)
            } else this.refreshChart(false)
          },
          deep: true
        }
      },
      methods: {
        updateGChart () {
          this.hasLegend()
          if (this.component.colors && this.component.typeChart === 'ColumnChart') {
            for (let row = 0; row < (Object.keys(this.result).length - 1); row++) {
              let columnArray = []
              if (this.result[row].length !== 0) {
                columnArray[0] = this.result[row][0]
                columnArray[1] = (row === 0) ? '' : parseFloat(this.result[row][1])
                columnArray[2] = (row === 0) ? { role: 'style' } : this.component.colors[row - 1]
                this.chartData[row] = columnArray
              }
            }
          } else {
            for (let row = 0; row < (Object.keys(this.result).length - 1); row++) {
              let columnArray = []
              if (this.result[row].length !== 0) {
                columnArray[0] = this.result[row][0]
                columnArray[1] = (row === 0) ? this.result[row][1] : parseFloat(this.result[row][1])
                this.chartData[row] = columnArray
              }
            }
            this.updateColor()
          }
          // if (this.component.typeChart === 'Table') {
          //   for (let row = 0; row < (Object.keys(this.result).length - 1); row++) {
          //     if (this.result[row].length !== 0) this.chartData[row] = this.result[row]
          //   }
          // }
        },
        updateColor () {
          if (this.component.colors) this.chartOptions.colors = this.component.colors
        },
        hasLegend () {
          if (this.component.legend === false) this.chartOptions.legend = { position: 'none' }
        },
        refreshChart (renderChart) {
          this.componentKey += 1
          this.isRendered = renderChart
        }
      }
    }
  </script>



// WEBPACK FOOTER //
// src/components/charts/GChart.vue